// Dynamically require all SCSS files in the current directory and subdirectories
const requireAll = (requireContext) => requireContext.keys().forEach(requireContext);
const styles = require.context('.', true, /\.scss$/);

requireAll(styles);